export const recursionDetectionMiddlewareOptions = {
    step: "build",
    tags: ["RECURSION_DETECTION", "TRACE_CONTEXT_PROPAGATION"],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low",
};
